import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PolicyDetailPage } from '@/features/policy-detail/policy-page'
import { requireActiveSubscription } from '@/lib/middleware'

// `policies_.$policyId` (underscore suffix on `policies_`) is a NON-nested
// sibling of `policies.tsx` in TanStack file routing — its generated path is
// `/compliance/policies/$policyId`, not a child route of the policies list
// page. Task 10 (phase 2, compliance-system) — replaces the old
// `PolicyViewDialog` with a real, deep-linkable page.
const searchSchema = z.object({
  tab: z.enum(['overview', 'grade', 'versions', 'acknowledgements', 'standards', 'activity']).optional(),
  filter: z.string().optional(),
  from: z.string().optional(),
  obligation: z.string().optional(),
  // Task 12 (redraft review) will read this to open a specific proposal.
  proposal: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/compliance/policies_/$policyId')({
  validateSearch: searchSchema,
  beforeLoad: async () => requireActiveSubscription(),
  component: PolicyDetailPage,
})
